module.exports = __webpack_public_path__ + "media/images/icon/target-f2bd311971aa7720138c1380c17014a5.svg";